import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
function loadLocaleMessages() {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}
export const supportLanguages = {
    en: {
        languages: {
            简中: 'Simplified Chinese',
            繁中: 'Traditional Chinese',
            英语: 'English',
            日语: 'Japanese',
            印尼语: 'Indonesian',
            韩语: 'Korean',
            泰语: 'Thai',
            越南语: 'Vietnamese',
            高棉语: 'Khmer',
            缅甸语: 'Burmese',
            葡萄牙语: 'Portuguese',
            西班牙语: 'Spanish',
            拉丁美洲西班牙语: 'Latin American Spanish',
            巴西葡萄牙语: 'Brazilian Portuguese',
            土耳其语: 'Turkish',
            俄语: 'Russian',
            印地语: 'Hindi',
            马来西亚语: 'Malay'
        }
    },
    cn: {
        languages: {
            简中: '简中',
            繁中: '繁中',
            英语: '英语',
            日语: '日语',
            印尼语: '印尼语',
            韩语: '韩语',
            泰语: '泰语',
            越南语: '越南语',
            高棉语: '高棉语',
            缅甸语: '缅甸语',
            葡萄牙语: '葡萄牙语',
            西班牙语: '西班牙语',
            拉丁美洲西班牙语: '拉丁美洲西班牙语',
            巴西葡萄牙语: '巴西葡萄牙语',
            土耳其语: '土耳其语',
            俄语: '俄语',
            印地语: '印地语',
            马来西亚语: '马来西亚语'
        }
    }
};
export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages()
});
